import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';
import SensorsIcon from '@mui/icons-material/Sensors';
import BaseCard from './BaseCard';
import { statBoxStyle, statValueStyle, statLabelStyle } from './cardStyles';
import { AQUA_MARINE, ZIMA_BLUE } from '../../../dashboardColors';

const SensorsInstalledCard = ({ data, t }) => {
  const total = (data?.active || 0) + (data?.inactive || 0);

  return (
    <BaseCard
      title={
        <Box display="flex" alignItems="center" gap={1}>
          <span>{t('sensors_installed')}</span>
          <Typography component="span" sx={{ color: AQUA_MARINE, fontWeight: 700, fontSize: '1.6rem' }}>
            {total}
          </Typography>
        </Box>
      }
      icon={<SensorsIcon />}
      className="compact-card"
    >
      <Box display="flex" alignItems="center" justifyContent="center" height="100%" gap={1.5}>
        <Box sx={statBoxStyle}>
          <Typography className="stat-value" sx={{ ...statValueStyle, color: ZIMA_BLUE }}>
            {data?.active || 0}
          </Typography>
          <Typography sx={statLabelStyle}># {t('active')}</Typography>
        </Box>
        <Box sx={statBoxStyle}>
          <Typography className="stat-value" sx={{ ...statValueStyle, color: ZIMA_BLUE }}>
            {data?.inactive || 0}
          </Typography>
          <Typography sx={statLabelStyle}># {t('inactive')}</Typography>
        </Box>
      </Box>
    </BaseCard>
  );
};

SensorsInstalledCard.propTypes = {
  data: PropTypes.shape({
    total: PropTypes.number,
    active: PropTypes.number,
    inactive: PropTypes.number
  }),
  t: PropTypes.func.isRequired
};

export default SensorsInstalledCard;
